export const transformCabana = (cabana) => {
  let string = '';

  switch (cabana) {
    case 'BAMBU':
      string = 'Bambu';
      break;
    case 'PIRUL':
      string = 'Pirul';
      break;
    case 'MEZQUITE':
      string = 'Mezquite';
      break;
    default:
      break;
  }

  return string;
};

export const filterRooms = (rooms, cabana) => {
  const newRooms = rooms.filter(
    (room) => room.short_name === transformCabana(cabana)
  );

  return newRooms;
};
